/* eslint-disable eqeqeq */
import {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
  useRef,
} from "react";

import { useSelector, useDispatch } from "react-redux";
import { DataGrid} from "@mui/x-data-grid";
 
import { OutboundGRV, vRdxUserInfo } from "../../Redux/roStore";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal"; 
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded"; 
import Box from "@mui/material/Box";
import {
  fcovertToNumber, 
} from "../../Utility/Utilitys";
import GCDiscountPercentage from "../../Component/Common/ReuseableComponent/GCDiscountPercentage";
import GCSearchBtn from "../../Component/Common/ReuseableComponent/GCSearchBtn";
import {
  fAlertToast,
  fCalculate_Detail,
  GetGitterColumns,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "../../Server/Apis";
import {
  ApproveWMINV04_GETROW,
  deleteDetailWMINV04_GETROW,
  deleteHeadWMINV04_GETROW,
  ReverseWMINV04_GETROW,
  validationWMINV04_GETROW,
} from "../../Server/ApiV2";
import { fKeyTabInput, fFocusInput } from "../../Utility/Utilitys";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
 
import WmsFooter from "./processComponent/WmsFooter";
import GCReverse from "../../Component/Common/ReuseableComponent/GCReverse";
import {
  Set_WmsOutboundGRV_HeadObject_Set,
  Set_WmsOutboundGRV_HeadObject_Init,
} from "./SliceWmsOutboundGRV";
import "./OutboundGRV.css";
import { Wms_OutboundGRV_HeadObject_New_Set } from "./SliceWmsOutboundGRV";
import { Set_OutboundGRV_HeadObject_A_DocStat } from "./SliceWmsOutboundGRV";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  CmpButton,
  CmpButtonKIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  fRightClick,
  fLeftClick,
  sFocFlagArr,
  //grid history
  GetSalesHistory,
  //grid history end
  sPaymode,
  sTax,
  sTrnTyp,
  TypeArr,
  sStatusArr,
  fKeyOutboundGRV,
  fKeyOutboundGRVContent,
  GetBuyer,
  GetDefaultDrCrAccount,
  GetUnitArr, 
  GetItemFullSearchArr,
  ItemSearchData,
  GetSearchItem,
  fItemCodeDependency,
  ErrorMsg,
  ErrorMsgDetail,
  fValidationHead_Client,
  fValidationDetail_Client, 
  fLoad_Grid, 
  fDisplay,
  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,
  GetTransTaxType,
  fDefaultPayload, 

  //Approve 

  //ref doc
  GetDefcustomersetting,

  //customer
  xGC_Toggle_Head_Customer_DropDown_Arr,
  Get_ToggleDropDown_Load,
  //narration
  GetItemStock,
  xGCSearchBtn_Columns_DropdownSearch,
  Get_GCSearchBtn,
  GetOSAmount,
  GetAttributes,
  getTransItemStockUOM,
  fSaveHead_Detsil,
  Unit_Onchange_001,
} from "./OutboundGRVAction";
// import { set } from 'date-fns/esm';
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { fCheck_Doc_Rights_001 } from "../../Utility/Utilitys";
import {
  FShortCutKey,
  GetAccountPostingDetail,
  GetLinkDocument,
} from "../../Utility/Utilitys";
import GCAccountDetail from "../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function WmsOutboundGRVV1() {
  const dispatch = useDispatch();
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector(
    (state) => state.SliceWmsOutboundGRV.value.HeadObject
  );

  const vRdxDBBranchList = useSelector(
    (state) => state.SliceDB.value.DBBranchList
  );
  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value

  const [sRoundingVal, setRoundingVal] = useState(4);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });

  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });

  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [sLoading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sArr, setArr] = useState([]);
  const [sGCSeachSalesGroupSearch, setGCSeachSalesGroupSearch] = useState([]); //GCSeachSalesGroupSearch Select
  //grid saleshistory
  const [sToggleGrid, setToggleGrid] = useState(false);
  const [sGridSalesHistoryRowData, setGridSalesHistoryRowData] = useState([]);
  //grid saleshistory

  //HEAD
  const [sDocLoading, setDocLoading] = useState([]);
  const [sUnloading, setUnloading] = useState([]);
  const [sCurrency, setCurrency] = useState([]);
  const [sOutboundType, setOutboundType] = useState([
    // "LOCAL"
  ]);

  const [sBuyer, setBuyer] = useState([]); //sBuyer Select
  const [sItemStock, setItemStock] = useState({
    rpStock: "",
  });
  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);
  const [sPaymodeEnable, setPaymodeEnable] = useState(true); //to set paymode enable or disable
  const [sOsAmount, setOsAmount] = useState({
    NetOsAmt: 0,
    PDCAmt: 0,
    BalanceOsAmt: 0,
  }); //to set paymode enable or disable
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  const [sFooterObj, setFooterObj] = useState({
    A_GrossAmt: (0).toFixed(sRoundingVal),
    A_TDiscAmt: (0).toFixed(sRoundingVal),
    A_LDiscAmt: (0).toFixed(sRoundingVal),
    A_FocAmt: (0).toFixed(sRoundingVal),
    A_NetExcise: (0).toFixed(sRoundingVal),
    A_Tax: (0).toFixed(sRoundingVal),
    A_Tax2: (0).toFixed(sRoundingVal),
    A_AddCess: (0).toFixed(sRoundingVal),
    A_LandVal: (0).toFixed(sRoundingVal),
    A_SplDiscAmt1: (0).toFixed(sRoundingVal),
  });

  //DETAIL
  const [sUnit, setUnit] = useState([]);
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select
  const [isSaveLoaded, setSaveLoaded] = useState(false);

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_RefDocTyp: "",
    B_RefDocTypName: "",
    B_RefDocNo: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Barcode: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    B_URateFc: (0).toFixed(sRoundingVal), //Decimal
    B_URateLc: (0).toFixed(sRoundingVal), //Decimal
    B_GrossAmt: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_FocFlag: "N",

    B_FocAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxNetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_NetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Base_Rate: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept: vRdxGRNtax1[0]?.UId,
    B_TaxPerc: vRdxGRNtax1[0]?.Perc, //Decimal
    B_TaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept2: vRdxGRNtax2[0]?.UId,
    B_TaxPerc2: vRdxGRNtax2[0]?.Perc, //Decimal
    B_TaxAmt2: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_CessAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_PCQty: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_PCRate: (0).toFixed(sRoundingVal), //Decimal
    AddCess: (0).toFixed(sRoundingVal), //Decimal //Addcess
    B_NetAddCess: (0).toFixed(sRoundingVal), //Decimal
    B_Total: (0).toFixed(sRoundingVal), //Decimal
    B_Narr: "",
    SplDiscPerc: (0).toFixed(sRoundingVal),
    SplDiscAmt: (0).toFixed(sRoundingVal),
    SplDisc: (0).toFixed(sRoundingVal),
    Narration: "",
    //ExtraAdded
    B_LandVal: "",
  };

  const [sBufferObj, setBufferObj] = useState({
    B_Srno: 0, // int
    B_RefDocTyp: "",
    B_RefDocTypName: "",
    B_RefDocNo: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Barcode: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    B_URateFc: (0).toFixed(sRoundingVal), //Decimal
    B_URateLc: (0).toFixed(sRoundingVal), //Decimal
    B_GrossAmt: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_LDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscPerc: (0).toFixed(sRoundingVal), //Decimal
    B_TDiscAmt: (0).toFixed(sRoundingVal), //Decimal
    B_FocFlag: "N",

    B_FocAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_ExciseTaxNetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_NetAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Base_Rate: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept: vRdxGRNtax1[0]?.UId,
    B_TaxPerc: vRdxGRNtax1[0]?.Perc, //Decimal
    B_TaxAmt: (0).toFixed(sRoundingVal), //Decimal
    B_TaxDept2: vRdxGRNtax2[0].UId,
    B_TaxPerc2: vRdxGRNtax2[0].Perc, //Decimal
    B_TaxAmt2: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_CessAmt: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_PCQty: (0).toFixed(sRoundingVal), //Decimal
    B_Ad_PCRate: (0).toFixed(sRoundingVal), //Decimal
    AddCess: (0).toFixed(sRoundingVal), //Decimal
    B_NetAddCess: (0).toFixed(sRoundingVal), //Decimal
    B_Total: (0).toFixed(sRoundingVal), //Decimal

    B_Narr: "",
    SplDiscPerc: (0).toFixed(sRoundingVal),
    SplDiscAmt: (0).toFixed(sRoundingVal),
    SplDisc: (0).toFixed(sRoundingVal),
    Narration: "",
    //ExtraAdded
    B_LandVal: "",
  });

  //Modal

  //Reverse
  const [sReverseTransactionModal, setReverseTransactionModal] =
    useState(false);
  const [sRevNarr, setRevNarr] = useState(""); //for Reverse API

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      A_PostDt: moment(vRdxWmsHead.A_PostDt).format("MM/DD/YYYY"),
      A_Loc: vRdxWmsHead.A_Loc,
      A_Party: vRdxWmsHead.A_Party,
      userCd: vRdxuserInfo.UserID,
      IP: vRdxuserInfo.IP,
      netAmt: sFooterObj.A_LandVal,
      revNarr: sRevNarr,
      v_DocStat: vRdxWmsHead.A_DocStat,
    };
    const vRevereTransaction = await ReverseWMINV04_GETROW(
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };
  //discount

  const [sDiscountPercentageModal, setDiscountPercentageModal] =
    useState(false);
  const fCloseDiscountPercentageModal = (e) => {
    setDiscountPercentageModal(false);
    setErrorMsgDiscountModal((obj) => ({
      ...obj,
      A_TDiscAmt: "",
      A_DiscPerc: "",
    }));
  };
  const fOpenDiscountPercentageModal = (e) => {
    setDiscPerModelObj({
      A_TDiscAmt: sFooterObj.A_TDiscAmt,
      A_DiscPerc: vRdxWmsHead.A_DiscPerc,
    });
    setDiscountPercentageModal(true);
  };

  const [sDiscPerModelObj, setDiscPerModelObj] = useState({
    A_TDiscAmt: sFooterObj.A_TDiscAmt,
    A_DiscPerc: vRdxWmsHead.A_DiscPerc,
  });
  const [sErrorMsgDiscountModal, setErrorMsgDiscountModal] = useState({
    A_TDiscAmt: "",
    A_DiscPerc: "",
  });
  let vErrorMsgDiscountModalInit = {
    A_TDiscAmt: "",
    A_DiscPerc: "",
  };
  const fonChangeInputDiscountModal = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_DiscPerc: Number(event.target.value),
      A_TDiscAmt: vTDiscAmt,
    }));
  };

  //DiscountAmt modal
  const fOnChangeTDiscAmtModal = (e) => {
    let vCheckValue =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt);
    let vTDiscPer =
      (fcovertToNumber(e.target.value) * 100) /
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_DiscPerc: vCheckValue === 0 ? 0 : fcovertToNumber(vTDiscPer),
      A_TDiscAmt: Number(e.target.value),
    }));
  };

  const fvalidateDiscount = () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    let iResp = true;
    if (sDiscPerModelObj.A_DiscPerc != 0 && sDiscPerModelObj.A_TDiscAmt == 0) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      sDiscPerModelObj.A_DiscPerc == 0 &&
      sDiscPerModelObj.A_TDiscAmt != 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      Number(sDiscPerModelObj.A_DiscPerc > 100) ||
      Number(sDiscPerModelObj.A_DiscPerc) < 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc:
          "DiscPerc  must be greater than 0 and less than or equal to 100",
      }));
      iResp = false;
    }
    return iResp;
  };

  const GetApplyTDiscount = async () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    if (fvalidateDiscount()) {
      let vApplyTDiscountObj = {
        B_VocTyp: vRdxWmsHead.A_VocTyp,
        B_VocNo: vRdxWmsHead.A_VocNo,
        TDiscPerc: sDiscPerModelObj.A_DiscPerc,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vApplyTDiscountObj);
      const vApplyTDiscount = await fExecuteAPI(
        "WMINV04_applyTDiscount_GETROW",
        FinalObj
      );
      if (vApplyTDiscount?.Type?.toUpperCase() === "SUCCESS") {
        dispatch(
          Set_WmsOutboundGRV_HeadObject_Set({
            ...vRdxWmsHead,
            A_DiscPerc: sDiscPerModelObj.A_DiscPerc,
          })
        );
        fCloseDiscountPercentageModal();
        fNewDetail(
          vRdxWmsHead.A_VocNo,
          vRdxWmsHead.A_Rounding,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.TaxType
        );
        setTimeout(() => {
          document.getElementsByName("B_ItmName")[0]?.focus();
        }, 100);
      } else {
        fAlertToast(
          "FAILED",
          !!vApplyTDiscount.Message
            ? vApplyTDiscount.Message
            : vApplyTDiscount.response.data.message
        );
      }
    }
  };

  //HEAD FUNCTION
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      vGrnType.Paymode,
      dispatch
    );
    setPaymodeEnable(PaymodeEnable);
    GetDefaultDrCrAccount(
      vGrnType?.VocTyp,
      currentPayMode,
      vRdxWmsHead.A_Party,
      dispatch
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_WmsOutboundGRV_HeadObject_Set({ ...vRdxWmsHead, A_PostDt: event.$d })
    // );
  };

  const fInvNo = (event) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_RefNo: event.target.value,
      })
    );
  };

  const fInvDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_WmsOutboundGRV_HeadObject_Set({ ...vRdxWmsHead, A_RefDt: event.$d })
    // );
  };

  const fOutboundType = (event) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_Type: event.target.value,
      })
    );
  };

  const fPaymode = (event) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_PayMode: event.target.value,
      })
    );
    GetDefaultDrCrAccount(
      vRdxWmsHead.A_VocTyp,
      event.target.value,
      vRdxWmsHead.A_Party,
      dispatch
    );
  };

  const fTax = async (event) => {
    var vUnloading = sTax.find((option, index) => {
      return option.Uid === event.target.value;
    });
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        TaxType: vUnloading.Uid,
        TaxTypeName: vUnloading.Name,
      })
    );
    //if inter.comp then tax group should be 0
    if (vUnloading.Uid == sTax[1].Uid || vUnloading.Uid == sTax[2].Uid) {
      InterCompanyDependency(
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
      );
    } else {
      if (sBufferObj.B_Itmcd === "") {
        InterCompanyDependency(vRdxGRNtax1[0]?.UId, vRdxGRNtax2[0].UId);
      } else {
        let vItemSearchFull = await GetItemFullSearchArr(
          sBufferObj.B_Itmcd,
          vRdxWmsHead.A_Loc
        );
        if (vItemSearchFull.length > 0) {
          ItemsAliasListSearch(vRdxWmsHead.A_Loc, vItemSearchFull[0].ItmCd);

          fItemCodeDependency(
            vItemSearchFull,
            vRdxWmsHead,
            sBufferObj,
            setBufferObj,
            setUnit,
            vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
            vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val,
            setItemStock
          );
        }
      }
    }
  };

  const fOffer = (event) => {
    if (event.target.checked) {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({ ...vRdxWmsHead, offer: "Y" })
      );
    } else {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({ ...vRdxWmsHead, offer: "N" })
      );
    }
  };
  const fTaxable = (event) => {
    if (event.target.checked) {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({ ...vRdxWmsHead, A_Taxable: "Y" })
      );
    } else {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({ ...vRdxWmsHead, A_Taxable: "N" })
      );
    }
  };

  const fUnloading = (event) => {
    var vUnloading = sUnloading.find((option, index) => {
      return option.UId === event.target.value;
    });
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        UnloadingBay: vUnloading?.UId,
        UnloadingBayName: vUnloading?.Name1,
      })
    );
  };

  const fCurrency = (event) => {
    var vCurrency = sCurrency?.find((option, index) => {
      return option.Uid === event.target.value;
    });

    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_Curr: vCurrency?.Uid,
        A_Currname: vCurrency?.Name1,
        A_ExRate: vCurrency?.Rate,
      })
    );
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vCurrency?.Rate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vRdxGRNtax1[0]?.Perc,
      vRdxGRNtax2[0].Perc,
      sBufferObj.AddCess,
      0
    );
    // setsSelectedCurrency(event.target.value);
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fLocation = async (e) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_Loc: e.target.value,
      })
    );
    GetDefcustomersetting(
      vRdxWmsHead.Party,
      e.target.value,
      vRdxWmsHead.A_Type,
      dispatch
    );
    ItemsAliasListSearch(e.target.value, sBufferObj.B_Itmcd);
    GetItemStock(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Srno,
      e.target.value,
      setItemStock,
      sBufferObj.B_PackQty
    );
  };

  //FOOTER FUNCTION
  const fBuyer = (e) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_Buyer: e.target.value,
      })
    );
  };

  const fNote = (e) => {
    // dispatch(Set_WmsOutboundGRV_HeadObject_Set(
    //     { ...vRdxWmsHead, A_Narr: e.target.value }
    // ));
  };

  const fHeadNarration = (e) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_Narr: e.target.value,
      })
    );
  };

  const fLandValueCalc = (event) => {
    let iLandVal =
      fcovertToNumber(sFooterObj.A_GrossAmt) +
      fcovertToNumber(sFooterObj.A_SplDiscAmt1) -
      fcovertToNumber(sFooterObj.A_TDiscAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt) -
      fcovertToNumber(sFooterObj.A_FocAmt) +
      fcovertToNumber(sFooterObj.A_NetExcise) +
      fcovertToNumber(sFooterObj.A_Tax) +
      fcovertToNumber(sFooterObj.A_Tax2) +
      fcovertToNumber(sFooterObj.A_AddCess) +
      fcovertToNumber(Number(event.target.value));

    setFooterObj((obj) => ({
      ...obj,
      A_LandVal: iLandVal.toFixed(2),
    }));
  };

  const fFooter_Rounding_Blur = (e) => {
    const iRounding = fcovertToNumber(e.target.value);
    if (iRounding == 0) {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: (0).toFixed(4),
        })
      );
      fLandValueCalc(e);
    }
  };

  const fFooter_Rounding_Focus = (e) => {
    if (e.target.value == 0) {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: "",
        })
      );
    }
  };

  const fRounding = (e) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_Rounding: e.target.value,
      })
    );
    fLandValueCalc(e);
  };

  //DETAIL  FUNCTION
  const fFocusShowSalesHistoryGrid = async () => {
    let vSalesHistoryArr = await GetSalesHistory(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Unit,
      vRdxWmsHead.A_Party,
      vRdxWmsHead.A_Loc,
      setGridSalesHistoryRowData
    );
    if (vSalesHistoryArr.length > 0) {
      setToggleGrid(true);
    } else {
      setToggleGrid(false);
    }
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
    setToggleGrid(false);
  };

  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
    }));
    await Unit_Onchange_001(
      vUnitvalue?.Unit,
      vUnitvalue,
      sBufferObj.B_Itmcd,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      setBufferObj,
      sBufferObj,
      setItemStock
    );
  };

  const fUnitRate = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: e.target.value,
    }));

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      Number(e.target.value),
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fGrossAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_GrossAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_URateFc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      0,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_URateFc,
    }));
  };

  const fUnitRateSave_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsHead.A_DocStat == "ENTER" &&
        !isSaveLoaded
      ) {
        setSaveLoaded(true);
        document.getElementsByName("B_URateFc")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };
  const fExcise = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ExciseTaxAmt: e.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      e.target.value,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fNetExcise = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ExciseTaxNetAmt: e.target.value,
    }));
  };

  const fTaxGroup = (e) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept: vtaxGroupValue?.UId,
      B_TaxPerc: vtaxGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };
  //if inter.comp then tax group should be 0
  const InterCompanyDependency = (xTaxID, xCessID) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == xTaxID;
    });
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == xCessID;
    });
    if (vtaxGroupValue) {
      setBufferObj((obj) => ({
        ...obj,
        B_TaxDept: vtaxGroupValue?.UId,
        B_TaxPerc: vtaxGroupValue?.Perc,
        B_TaxDept2: vCessGroupValue?.UId,
        B_TaxPerc2: vCessGroupValue?.Perc,
      }));
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
    return {
      B_TaxPerc: vtaxGroupValue?.Perc,
      B_TaxPerc2: vCessGroupValue?.Perc,
    };
  };
  const fCessGroup = (e) => {
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept2: vCessGroupValue?.UId,
      B_TaxPerc2: vCessGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fLDiscPer = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscPerc: e.target.value,
    }));
    if (e.target.value <= 100) {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate,
        sBufferObj.B_URateFc,
        e.target.value,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        sBufferObj.B_TaxPerc,
        sBufferObj.B_TaxPerc2,
        sBufferObj.AddCess,
        0
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      }));
    }
  };

  const fonChangeInputLDiscAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_LDiscPerc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      0,
      sBufferObj.B_GrossAmt,
      false,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_LDiscPerc,
    }));
  };

  const fItemName = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      e.target.value == "" ? 0 : e.target.value,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fBaseRate = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Base_Rate: e.target.value,
    }));
  };
  const fNetAmt = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_NetAmt: e.target.value,
    }));
  };

  //Item Dropdowm
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
    setLoading(true);

    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxWmsHead.A_Loc
      );

      if (vItemSearchFull.length > 0) {
        ItemsAliasListSearch(vRdxWmsHead.A_Loc, vItemSearchFull[0].ItmCd);

        fItemCodeDependency(
          vItemSearchFull,
          vRdxWmsHead,
          sBufferObj,
          setBufferObj,
          setUnit,
          vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
          vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val,
          setItemStock
        );
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        0, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        vRdxGRNtax1[0]?.Perc, //tax1%
        vRdxGRNtax2[0].Perc, //tax%2
        0, //sBufferObj.AddCess,
        0 //Rounding
      );
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_TaxAmt,
        B_TaxAmt2,
        B_Rounding,
        B_NetAddCess,
        B_LandVal,
      }));
      GetItemStock("", sBufferObj.B_Srno, vRdxWmsHead.A_Loc, setItemStock, 0);
      setUnit([]);
    }
  };

  //MODAL HEAD

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_Loc
    );
    if (vItemSearchFull.length > 0) {
      ItemsAliasListSearch(vRdxWmsHead.A_Loc, vItemSearchFull[0].ItmCd);

      fItemCodeDependency(
        vItemSearchFull,
        vRdxWmsHead,
        sBufferObj,
        setBufferObj,
        setUnit,
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val,
        setItemStock
      );
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  //GCCustomer Search

  const xfGC_Toggle_Head_Customer_Name = (e) => {
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_PartyName: e.target.value,
      })
    );
  };

  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);
  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
      setItemToggleDropdown(false);
      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
      setItemToggleDropdown(false);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: vRdxWmsHead.A_PartyName,
      }));
      if (vRdxWmsHead.A_PartyName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          vRdxWmsHead.A_PartyName,
          "Any",
          "C",
          "N",
          dispatch
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };

  //1stcall
  const fGC_Toggle_Head_Customer_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        vRdxWmsHead.A_PartyName,
        "Any",
        "C",
        "Y",
        dispatch
      );
      // let iDefaultTaxType = await GetTransTaxType(
      //   vRdxuserLoc[0].UID,
      //   vExactSearch[0]?.AcCd
      // );

      if (vExactSearch.length > 0) {
        let vDefaultTaxType = sTax[0].Uid;
        let iDefaultTaxType = await GetTransTaxType(
          vRdxWmsHead.A_Loc,
          vExactSearch[0]?.AcCd,
          dispatch
        );
        if (Object.keys(iDefaultTaxType).length != 0) {
          vDefaultTaxType = iDefaultTaxType?.TaxType;
        }
        //if inter.comp then tax group should be 0
        if (vDefaultTaxType == sTax[1].Uid || vDefaultTaxType == sTax[2].Uid) {
          InterCompanyDependency(
            vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
            vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
          );
        }
        dispatch(
          Set_WmsOutboundGRV_HeadObject_Set({
            ...vRdxWmsHead,
            A_Party: vExactSearch[0]?.AcCd,
            A_PartyName: vExactSearch[0]?.Name1,
            TaxType: vDefaultTaxType,
          })
        );

        GetDefaultDrCrAccount(
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_PayMode,
          vExactSearch[0]?.AcCd,
          dispatch
        );
        setTimeout(() => {
          fKeyTabInput(e, "B_ItmName");
        }, 500);
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
      if (vRdxWmsHead.A_Party != "") {
        setTimeout(() => {
          fKeyTabInput(e, "B_ItmName");
        }, 500);
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_WmsOutboundGRV_HeadObject_Set({
          ...vRdxWmsHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_Customer_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        "C",
        "N",
        dispatch
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_Customer_OnRowClick = async (e) => {
    let vDefaultTaxType = sTax[0].Uid;
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc,
      e?.row?.AcCd,
      dispatch
    );
    if (Object.keys(iDefaultTaxType).length != 0) {
      vDefaultTaxType = iDefaultTaxType?.TaxType;
    }
    //if inter.comp then tax group should be 0
    if (vDefaultTaxType == sTax[1].Uid || vDefaultTaxType == sTax[2].Uid) {
      InterCompanyDependency(
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
      );
    }
    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
        TaxType: vDefaultTaxType,
      })
    );

    GetDefaultDrCrAccount(
      vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_PayMode,
      e?.row?.AcCd,
      dispatch
    );

    xfGC_Toggle_Head_Customer_Toggle();
  };

  const fGC_Toggle_Head_Customer_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_Customer_OnRowClick(newSelectionModel);
    }
  };

  //GC CustomerSearch End

  //narration toggle start
  const [sNarrationToggleDropdown, setNarrationToggleDropdown] =
    useState(false);
  const [sNarrationSearchGridData, setNarrationSearchGridData] = useState([]); //for Narration search
  const [sNarrationSearchGridFullData, setNarrationSearchGridFullData] =
    useState([]); //for Narration full data
  const ffilterNarrationDropDownSearch = useCallback((xValue, xArray) => {
    let vNewFilterSearchArr = xArray?.filter((obj) => {
      return (
        obj.Code.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase()) ||
        obj.Name.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase())
      );
    });
    if (xValue !== "") {
      setNarrationSearchGridData(vNewFilterSearchArr);
    } else {
      setNarrationSearchGridData(xArray);
    }
  }, []);

  const fNarration = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e.target.value,
    }));
    ffilterNarrationDropDownSearch(
      e.target.value,
      sNarrationSearchGridFullData
    );
  };

  const fNarrationKeyEnter = (e) => {
    if (e.key == "Enter" || e._reactName === "onClick") {
      setNarrationToggleDropdown(!sNarrationToggleDropdown);
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  //Narration input search
  const OnRowNarrationClick = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e?.row?.Name,
    }));
    setNarrationToggleDropdown(false);
  };

  //Narration input search
  const OnCellKeyNarrationDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      OnRowNarrationClick(newSelectionModel);
    }
  };

  //API ItemsAliasList_GETROW
  const ItemsAliasListSearch = async (xLoc, xItmCd) => {
    let ItemsAliasListSearchObj = {
      ItmCd: xItmCd,
      Loc: xLoc,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(ItemsAliasListSearchObj);
    const vItemsAliasListSearchSearch = await fExecuteAPI(
      "ItemsAliasList_GETROW",
      FinalObj
    );
    if (vItemsAliasListSearchSearch?.Type == "SUCCESS") {
      // PostDate: moment(obj.PostDate).format("DD/MM/YYYY")
      let GridID = vItemsAliasListSearchSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setNarrationSearchGridData(GridID);
      setNarrationSearchGridFullData(GridID);
      return GridID;
    } else if (vItemsAliasListSearchSearch.Type == "FAILED") {
      fAlertToast("FAILED", vItemsAliasListSearchSearch.Message);
      return [];
    } else if (
      vItemsAliasListSearchSearch.response.status == 500 ||
      vItemsAliasListSearchSearch.response.status == 400
    ) {
      fAlertToast("FAILED", vItemsAliasListSearchSearch.response.data.message);
      return [];
    } else {
      fAlertToast("FAILED", "Error in loading ItemsAliasListSearchSearch");
      return [];
    }
  };

  //narration toggle end

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal GCSearch
  const [sSearchLoactionArr, setSearchLoactionArr] = useState(vRdxDBLocation);
  const addAllInSearchLoactionArr = () => {
    const newObj = {
      UID: "All",
      Name1: "All",
      BranchCode: "All",
      BranchName: "All",
    };

    // Use the spread operator to create a new array with the new object added at the beginning
    setSearchLoactionArr([newObj, ...sSearchLoactionArr]);
  };
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: "All",
    RefNo: "",
    SalesGroup: "",
    Party: "All",
    PartyName: "All",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModal(true);
    document.getElementById("IdSearch")?.blur();
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    let iSalesGroupArr = await GetSalesGroupSearch(vRdxWmsHead.A_Loc);
    if (iSalesGroupArr.length > 0) {
      setGCSeachSalesGroupSearch(iSalesGroupArr);
      addAllInSearchLoactionArr();
      setSearchModalObj({
        ...sSearchModalObj,
        SalesGroup: iSalesGroupArr[0]?.UId,
      });
      GetSearchValue("", "APICallSalesGroupModal", iSalesGroupArr[0]?.UId);
    }
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: "All",
      RefNo: "",
      SalesGroup: sGCSeachSalesGroupSearch[0]?.UId,
      Party: "All",
      PartyName: "All",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail, setBuyer);
    fCloseSearchModal();
    fClearSearchModal();
  };
  //GCSearch
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
      // fDisplay(
      //   newSelectionModel?.row?.A_VocTyp,
      //   newSelectionModel?.row?.A_VocNo,
      //   fNewDetail,
      //   setBuyer
      // );
      // fCloseSearchModal();
      // fClearSearchModal();
    }
  };
  //GCSearchBtn Start
  const xfGCSearchBtn_Name = (e) => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModalObj((obj) => ({
      ...obj,
      Party: "",
      PartyName: e.target.value,
    }));
  };

  const [
    sGCSearchBtn_SearchDropdownObj_SearchDropdownObj,
    setGCSearchBtn_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGCSearchBtn_GridData, setGCSearchBtn_GridData] = useState([]);
  const [sGCSearchBtn_Toggle_ToggleDropDowm, setGCSearchBtn_ToggleDropDowm] =
    useState(false);

  const xfGCSearchBtn_Toggle = useCallback(() => {
    if (sGCSearchBtn_Toggle_ToggleDropDowm) {
      setGCSearchBtn_ToggleDropDowm(false);
      setGCSearchBtn_GridData([]);
      setGCSearchBtn_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGCSearchBtn_ToggleDropDowm(true);
    }
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  //2nd call
  const fGCSearchBtn_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCSearchBtn_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sSearchModalObj.PartyName,
      }));
      if (sSearchModalObj.PartyName != "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "N"
        );
        setGCSearchBtn_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGCSearchBtn_Toggle();
    }
  };

  //1stcall
  const fGCSearchBtn_onKeyUp_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sSearchModalObj.Party == "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "Y"
        );
        if (vLandedCostExactSearch.length > 0) {
          setSearchModalObj((obj) => ({
            ...obj,
            Party: vLandedCostExactSearch[0].AcCd,
            PartyName: vLandedCostExactSearch[0].Name2,
          }));
          GetSearchValue(
            "",
            "APICallPartyModal",
            vLandedCostExactSearch[0].AcCd
          );
        } else {
          fGCSearchBtn_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setSearchModalObj((obj) => ({
        ...obj,
        Party: "",
      }));
    }
  };

  const xGCSearchBtn_Dropdown_onChange = (e) => {
    setGCSearchBtn_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGCSearchBtn__Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_GCSearchBtn(
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Data,
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Type
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setGCSearchBtn_GridData(vLandedCostDropdownSearch);
      } else {
        setGCSearchBtn_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document?.getElementsByClassName("Mui-selected")?.length;
        if (selectedLength === 0) {
          let tabel = document?.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCSearchBtn_OnRowClick = (e) => {
    setSearchModalObj((obj) => ({
      ...obj,
      Party: e?.row?.AcCd,
      PartyName: e?.row?.Name2,
    }));
    GetSearchValue("", "APICallPartyModal", e?.row?.AcCd);
    xfGCSearchBtn_Toggle();
  };
  const fGCSearchBtn_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCSearchBtn_OnRowClick(newSelectionModel);
    }
  };
  //GCSearchBtn End

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALL", vSelectedValue);
  };
  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };
  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: !!event.target.value
    //     ? moment(event.target.value, "YYYY-MM-DD")._d
    //     : "",
    // }));
    // let changedDate = moment(event.target.value, "YYYY-MM-DD")._d;
    // if (new Date(event.target.value) > new Date("01/01/1990")) {
    //   GetSearchValue("", "APICALLDATE", changedDate);
    // }
  };
  const fonChangePartyModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.AcCd == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Party: vSelectedValue.AcCd,
    }));
    GetSearchValue("", "APICallPartyModal", vSelectedValue.AcCd);
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UID == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UID,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UID);
  };

  const fonChangeSalesGroupModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      SalesGroup: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallSalesGroupModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    setLoading(true);
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALL" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallPartyModal" ||
      xAPICALL === "APICallLocModal" ||
      xAPICALL === "APICallSalesGroupModal"
    ) {
      let vSearchObj = {
        VocNo: sSearchModalObj.VocNo,
        PostDt:
          xAPICALL === "APICALLDATE"
            ? moment(xSTATUS).format("MM/DD/YYYY")
            : !!sSearchModalObj.PostDt
            ? moment(sSearchModalObj.PostDt).format("MM/DD/YYYY")
            : "01/01/1900",
        // PostDt: "01/01/1900",
        RefNo: sSearchModalObj.RefNo,
        Party:
          xAPICALL === "APICallPartyModal"
            ? !!xSTATUS
              ? xSTATUS
              : "All"
            : !!sSearchModalObj.Party
            ? sSearchModalObj.Party
            : "All",
        Type: "",
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        Status: xAPICALL === "APICALL" ? xSTATUS : sSearchModalObj.Status,
        UserCd: vRdxuserInfo.UserID,
        SalesGroup:
          xAPICALL === "APICallSalesGroupModal"
            ? xSTATUS
            : sSearchModalObj.SalesGroup,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const vSearch = await fExecuteAPI("WMINV04_search_GETROW", FinalObj);
      if (vSearch?.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
        setLoading(false);
      } else {
        fAlertToast("FAILED", vSearch.Message);
      }
    }
    setLoading(false);
  };

  //API SALESGROUP
  const GetSalesGroupSearch = async (xA_Loc) => {
    const vSalesGroupSearchs = await fExecuteAPI(
      "SALESGROUPSSEARCH_GETROW",
      xA_Loc
    );
    if (vSalesGroupSearchs.Type == "SUCCESS") {
      return vSalesGroupSearchs.ResultSet;
    } else {
      fAlertToast("FAILED", vSalesGroupSearchs.Message);
    }
  };
  //Modal Audit

  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = OutboundGRV();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = OutboundGRV();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //document
  const [sDocumentModal, setDocumentModal] = useState(false);
  const fDocument = () => {
    fOpenDocumentModal();
  };
  const fOpenDocumentModal = () => {
    setDocumentModal(true);
  };
  const fCloseDocumentModal = (e) => {
    setDocumentModal(false);
  };

  //GCLandedCost

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField?.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vTransAuditObj);
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", FinalObj);
    if (vTransAudit?.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };

  //API DETAIL

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[0].A_VocTyp,
      sUser_Doc_Arr[0].A_VocNo,
      dispatch,
      fNewDetail,
      setBuyer
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo,
      dispatch,
      fNewDetail,
      setBuyer
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail,
        setBuyer
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        dispatch,
        fNewDetail,
        setBuyer
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let vrdl = vRdxDBBranchList.find((obj) => {
        return obj.LocName[0] == vRdxWmsHead.A_Loc;
      });
      let webReport = vRdxDBKernObj.WEB_REPORT_BASE_URL;

      //  /WMS/GRN?trntyp=WMINV03&voctyp=WS001&vocno=WS/0000001&prntyp=PC
      if (vrdl?.InvoiceFile != "") {
        let urlPrint =
          webReport?.Val +
          "WMS/GRV?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp;
        //  +
        // "&amountInWord=''" +
        // "&rdl=" +
        // vrdl?.InvoiceFile;
        setWebReportUrlModal(urlPrint);
        fWebReport();
      } else {
        let urlPrint =
          webReport?.Val +
          "WMS/GRV?trntyp=" +
          sTrnTyp +
          "&voctyp=" +
          vRdxWmsHead.A_VocTyp +
          "&vocno=" +
          vRdxWmsHead.A_VocNo +
          "&prnTyp=" +
          xPrnTyp +
          "&amountInWord=''";
        setWebReportUrlModal(urlPrint);
        fWebReport();
      }
    },
    [
      vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_VocNo,
      vRdxWmsHead.A_VocTyp,
      vRdxDBKernObj,
      vRdxDBBranchList,
    ]
  );

  const processResponse = (
    response,
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = async () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        await handleSaveOrApprove(xsave, docstatus);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };
  const validation_Save_ServerSide = async () => {
    const { HeadObject } = OutboundGRV();
    const vRdxUserInfoObj = vRdxUserInfo();

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Loc: HeadObject.A_Loc,
      v_A_Party: HeadObject.A_Party,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Unit: sBufferObj.B_Unit,
      v_TaxType: HeadObject.TaxType,
      v_TaxDept: sBufferObj.B_TaxDept,
      v_TaxPerc: sBufferObj.B_TaxPerc,
      v_TaxDept2: sBufferObj.B_TaxDept2,
      v_B_BaseQty: sBufferObj.B_BaseQty,
    };
    let resp = await validationWMINV04_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      return true;
      // if (resp?.data?.ResultSet?.length > 0) {
      //   //in this case it will ask or confirmation
      //   processResponse(resp?.data.ResultSet);
      // } else {
      //   return true;
      // }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );

        const errorField = resp?.response?.data?.message?.field;
        const errorMsg = resp?.response?.data?.message?.msg;
        if (ErrorMsgDetail.hasOwnProperty(errorField)) {
          setErrorMsgDetail((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        } else if (errorMsg.hasOwnProperty(errorField)) {
          setErrorMsg((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        }

        document
          ?.getElementsByName([resp?.response?.data?.message?.field])[0]
          ?.focus();
      }
      return false;
    }
  };
  const handleSaveOrApprove = async (
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    if (vRdxWmsHead.A_VocNo == "0" || !xsave) {
      setTimeout(() => {
        confirmAlert({
          title: `${xsave ? "Save" : "Approve"}`,
          message: `Are you want to ${xsave ? "Save" : "Approve"}?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                fSaveHead_Detsil(
                  xsave,
                  setUser_Doc_Arr,
                  sUser_Doc_Arr,
                  dispatch,
                  fNewDetail,
                  sBufferObj,
                  setBuyer,
                  docstatus
                );
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
      setTimeout(() => {
        document.getElementsByName("SaveYes")[0]?.focus();
      }, 150);
    } else if (xsave) {
      await fSaveHead_Detsil(
        xsave,
        setUser_Doc_Arr,
        sUser_Doc_Arr,
        dispatch,
        fNewDetail,
        sBufferObj,
        setBuyer,
        docstatus
      );
    }
  };

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fCloseReverseTransactionModal(setReverseTransactionModal);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      setSaveLoaded(false);

      if (vRdxWmsHead.A_DocStat == "POST" || vRdxWmsHead.A_DocStat == "DRAFT") {
        if (sRevNarr == "") {
          fOpenReverseTransactionModal(setReverseTransactionModal);
        } else {
          confirmAlert({
            title: "Reverse",
            message: `Are you sure to Reverse.`,
            buttons: [
              {
                className: "alertBtn",
                label: "Yes",
                onClick: async () => {
                  let resp = await GetRevereTransaction();
                  if (resp?.status === 200) {
                    fClearErrorMsg();
                    setRevNarr("");
                    dispatch(
                      Set_OutboundGRV_HeadObject_A_DocStat({
                        A_DocStat: "ENTER",
                      })
                    );
                    fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
                  }
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {},
              },
            ],
          });
        }
      } else if (vRdxWmsHead.A_DocStat !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(
          vRdxWmsHead,
          setErrorMsg,
          sFooterObj,
          vMediaQuery,
          fSummary
        );

        if (!validation) return;

        let validationDetil = fValidationDetail_Client(
          vRdxWmsHead,
          sBufferObj,
          setErrorMsgDetail,
          sDetailGridData
        );

        if (!validationDetil) return;
        let server_Validation = await validation_Save_ServerSide();
        if (!server_Validation) return;

        if (server_Validation) {
          await handleSaveOrApprove(true);
        }
      }
    }, 200);
  };

  const ValidationApprove = async (xbool, docstatus) => {
    const { HeadObject } = OutboundGRV();
    const vRdxUserInfoObj = vRdxUserInfo();
    let obj = {
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_UserId: vRdxUserInfoObj.UserID,
      v_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_Party: HeadObject.A_Party,
      v_Loc: HeadObject.A_Loc,
      v_Offer: HeadObject.offer,
      v_A_Buyer: HeadObject.A_Buyer,
      v_A_CrAc: HeadObject.A_CrAc,
      v_A_DrAc: HeadObject.A_DrAc,
    };
    let resp = await ApproveWMINV04_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );

    if (resp?.status === 200) {
      return true;
    } else {
      if (resp.response.status == 500) {
        if (resp?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        } else {
          const errorField = resp?.response?.data?.message?.field;
          const errorMsg = resp?.response?.data?.message?.msg;
          if (ErrorMsgDetail.hasOwnProperty(errorField)) {
            setErrorMsgDetail((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else if (errorMsg.hasOwnProperty(errorField)) {
            setErrorMsg((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          }

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(
        vRdxWmsHead,
        setErrorMsg,
        sFooterObj,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;
      let Searver_ValidationApprove = await ValidationApprove(
        false,
        xDocStatus
      );
      if (!Searver_ValidationApprove) return;
      if (!!Searver_ValidationApprove) {
        setTimeout(() => {
          confirmAlert({
            title: "Approve",
            message: "Are you want to Approve..",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: async () => {
                  await fSaveHead_Detsil(
                    false,
                    setUser_Doc_Arr,
                    sUser_Doc_Arr,
                    dispatch,
                    fNewDetail,
                    sBufferObj,
                    setBuyer,
                    xDocStatus
                  );
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {
                  return;
                },
              },
            ],
          });
        }, 200);
      }
    }, 200);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
    setRevNarr("");
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      let idefaultTaxTypeValue = sTax[0]?.Uid;
      let iDefaultTaxType = await GetTransTaxType(
        vRdxDBLocation[0].UID, //locaation
        "", //partyname in new it is empty,
        dispatch
      );

      if (Object.keys(iDefaultTaxType).length != 0) {
        idefaultTaxTypeValue = iDefaultTaxType?.TaxType;
      }

      fNewHead();
      fNewDetail(0, 0, sDocLoading[0]?.VocTyp, idefaultTaxTypeValue);
      document.getElementsByName("A_PostDt")[0]?.focus();
    } else {
      fNewDetail(
        vRdxWmsHead.A_VocNo,
        vRdxWmsHead.A_Rounding,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.TaxType
      );
    }
  };

  const fNewHead = async () => {
    dispatch(Set_WmsOutboundGRV_HeadObject_Init()); // Head Clearing
    let idefaultTaxTypeValue = sTax[0].Uid;
    let iDefaultTaxType = await GetTransTaxType(
      vRdxDBLocation[0]?.UID, //locaation
      "", //partyname in new it is empty,
      dispatch
    );

    if (Object.keys(iDefaultTaxType).length != 0) {
      idefaultTaxTypeValue = iDefaultTaxType?.TaxType;
    }

    // Setting Initial List Box 0th Object
    dispatch(
      Wms_OutboundGRV_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: vRdxDBLocation[0]?.UID,
        A_Curr: sCurrency[0]?.Uid,
        A_ExRate: sCurrency[0]?.Rate,
        A_Buyer: sBuyer.length > 0 ? sBuyer[0].UId : "",
        TaxType: idefaultTaxTypeValue,
        UnloadingBay: sUnloading[0]?.UId,
        A_Type: sOutboundType[0], //sForm
        offer: "N",
      })
    );

    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      sDocLoading[0]?.Paymode,
      dispatch
    );
    setPaymodeEnable(PaymodeEnable);

    GetDefaultDrCrAccount(
      sDocLoading[0].VocTyp,
      currentPayMode,
      "", //party
      dispatch
    );

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: (0).toFixed(sRoundingVal),
      A_SplDiscAmt1: (0).toFixed(sRoundingVal),
      A_TDiscAmt: (0).toFixed(sRoundingVal),
      A_LDiscAmt: (0).toFixed(sRoundingVal),
      A_FocAmt: (0).toFixed(sRoundingVal),
      A_NetExcise: (0).toFixed(sRoundingVal),
      A_Tax: (0).toFixed(sRoundingVal),
      A_Tax2: (0).toFixed(sRoundingVal),
      A_AddCess: (0).toFixed(sRoundingVal),
      A_LandVal: (0).toFixed(sRoundingVal),
    }));

    GetItemStock(
      "",
      sBufferObj.B_Srno,
      vRdxDBLocation[0]?.UID,
      setItemStock,
      0
    );
    // document.getElementsByName("A_RefDocNo")[0]?.focus();
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = (xVocNo, xRounding, xVocTyp, vTaxType) => {
    setBufferObj(vBufferObjInit);
    const { HeadObject } = OutboundGRV();
    setBufferObj((obj) => ({
      ...obj,
      B_TDiscPerc: HeadObject?.A_DiscPerc,
    }));
    GetItemStock("", 0, vRdxWmsHead.A_Loc, setItemStock, 0);

    //if inter.comp then tax group should be 0
    let iTaxPerc = 0;
    let iCessPerc = 0;
    if (vTaxType == sTax[1].Uid || vTaxType == sTax[2].Uid) {
      let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
        return obj.UId == vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val;
      });
      let vCessGroupValue = vRdxGRNtax2.find((obj) => {
        return obj.UId == vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val;
      });
      if (vtaxGroupValue) {
        setBufferObj((obj) => ({
          ...obj,
          B_TaxDept: vtaxGroupValue?.UId,
          B_TaxPerc: vtaxGroupValue?.Perc,
          B_TaxDept2: vCessGroupValue?.UId,
          B_TaxPerc2: vCessGroupValue?.Perc,
        }));
      }
      iTaxPerc = vtaxGroupValue?.Perc;
      iCessPerc = vCessGroupValue?.Perc;
    }
    setUnit([]);
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      sCurrency[0]?.Rate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      HeadObject?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      vTaxType == sTax[1].Uid || vTaxType == sTax[2].Uid
        ? iTaxPerc
        : vRdxGRNtax1[0]?.Perc, //tax1%
      vTaxType == sTax[1].Uid || vTaxType == sTax[2].Uid
        ? iCessPerc
        : vRdxGRNtax2[0].Perc, //tax%2
      0, //sBufferObj.AddCess,
      0 //Rounding
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));

    fLoad_Grid(xVocNo, 0, xRounding, setDetailGridData, setFooterObj, xVocTyp);

    document.getElementsByName("B_ItmName")[0]?.focus();
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Srno === 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // DELETESIHEAD_GETROW

  const fDeleteHead = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIHeadObj = {
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      IP: vRdxuserInfo.IP,
      UserId: vRdxuserInfo.UserID,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIHeadObj);
    const resp = await deleteHeadWMINV04_GETROW(FinalObj);

    if (resp?.status === 200) {
      if (Srno == 0) {
        // vocno,srno
        dispatch(
          Set_OutboundGRV_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_VocNo,
          dispatch,
          fNewDetail,
          setBuyer
        );

        fAlertToast("SUCCESS", "Successfully Deleted");
      }
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIDetailObj = {
      B_VocTyp: vRdxWmsHead.A_VocTyp,
      B_VocNo: vRdxWmsHead.A_VocNo,
      B_Srno: Srno,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const resp = await deleteDetailWMINV04_GETROW(FinalObj);

    if (resp?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(
        vRdxWmsHead.A_VocNo,
        0,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.TaxType
      );
    }
  };

  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_VocTyp: vRdxWmsHead.A_VocTyp,
      B_VocNo: vRdxWmsHead.A_VocNo,
      B_Srno: item.row.B_Srno,
      B_Itmcd: item.row.B_Itmcd,
      // B_Barcode: "",
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.B_Qty,
      B_Unit: item.row.B_Unit,
      B_UnitName: item.row.UnitName,
      // B_PackQty: item.row.B_PackQty, //not in grid
      B_URateFc: item.row.B_URateFc,
      B_GrossAmt: item.row.B_GrossAmt,
      B_LDiscPerc: item.row.B_LDiscPerc,
      B_LDiscAmt: item.row.B_LDiscAmt,
      B_TDiscPerc: item.row.B_TDiscPerc,
      B_TDiscAmt: item.row.B_TDiscAmt,

      B_ExciseTaxAmt: item.row.B_ExciseTaxAmt,
      B_ExciseTaxNetAmt: item.row.B_ExciseTaxNetAmt,
      B_NetAmt: item.row.B_NetAmt,
      B_TaxDept: item.row.B_TaxDept,
      B_TaxPerc: item.row.B_TaxPerc,
      B_TaxAmt: item.row.B_TaxAmt,
      B_TaxDept2: item.row.B_TaxDept2,
      B_TaxPerc2: item.row.B_TaxPerc2,
      B_TaxAmt2: item.row.B_TaxAmt2,
      AddCess: item.row.AddCess,
      B_NetAddCess: item.row.B_NetAddCess,
      B_Rounding: item.row.B_Rounding ? item.row.B_Rounding : 0,
      B_LandVal: item.row.B_LandVal,
      B_BaseQty: item.row.B_BaseQty,
      B_URateLc: item.row.B_URateLc,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
    }));
    GetItemStock(
      item.row.B_Itmcd,
      item.row.B_Srno,
      vRdxWmsHead.A_Loc,
      setItemStock,
      vUnitvalue?.PackQty
    );
    fCloseViewModal();
  };

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      setItemToggleDropdown(false);
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    let iAttributeResp = await GetAttributes(
      setObjectRights,
      setUser_Doc_Arr,
      setDocLoading,
      setUnloading,
      setCurrency,
      setOutboundType
    );
    console.log("iAttributeResp", iAttributeResp);
    const vTransParty = iAttributeResp?.TransParty;
    if (vTransParty.length > 0) {
      let partyInitValue = vTransParty?.find((obj) => {
        return obj.AcCd.toUpperCase() === "ALL";
      });
      if (!!partyInitValue) {
        setSearchModalObj({
          ...sSearchModalObj,
          Party: partyInitValue?.AcCd,
        });
      }
    }

    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };

    let vDocLoadingArr = iAttributeResp?.DocLoading;

    if (vDocLoadingArr.length > 0) {
      icurrentDocLoading = vDocLoadingArr[0];
    }

    let icurrentUnloadingBayValue = {
      UId: "",
      Name1: "",
    };
    let vUnloadingBayArr = iAttributeResp?.UnloadingBay;
    if (vUnloadingBayArr.length > 0) {
      icurrentUnloadingBayValue = vUnloadingBayArr[0];
    }

    var iCurrencyArr = {
      Uid: "",
      Name1: "",
      Rate: 0,
    };
    let vCurrencyArr = iAttributeResp?.Currency;
    if (vCurrencyArr.length > 0) {
      iCurrencyArr = !!vCurrencyArr[0] ? vCurrencyArr[0] : iCurrencyArr;
    }

    var iOutboundTypeArr = "";
    let vOutboundTypeArr = iAttributeResp?.Type;
    if (vOutboundTypeArr.length > 0) {
      iOutboundTypeArr = vOutboundTypeArr[1];
    }
    //Grn Buyer select api
    var BuyerId = "";

    const vBuyer = await GetBuyer(
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? vRdxDBLocation[0].UID
        : vRdxWmsHead.A_Loc,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_VocNo,
      dispatch
    );
    if (vBuyer.length > 0) {
      setBuyer(vBuyer);
      BuyerId = vBuyer[0].UId;
    }

    let vDefaultTaxType = sTax[0].Uid;
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? vRdxDBLocation[0].UID
        : vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_Party,
      dispatch
    );

    if (Object.keys(iDefaultTaxType).length != 0) {
      vDefaultTaxType = iDefaultTaxType?.TaxType;
    }

    // Object.keys(obj).length === 0
    let { currentPayMode, PaymodeEnable } = fDefaultPayload(
      vDocLoadingArr[0]?.Paymode,
      dispatch
    );

    setPaymodeEnable(PaymodeEnable);

    dispatch(
      Set_WmsOutboundGRV_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,
        UnloadingBay:
          vRdxWmsHead.UnloadingBay == "" ||
          vRdxWmsHead.UnloadingBay === null ||
          vRdxWmsHead.UnloadingBay === undefined
            ? icurrentUnloadingBayValue.UId
            : vRdxWmsHead.UnloadingBay,

        UnloadingBayName:
          vRdxWmsHead.UnloadingBayName == "" ||
          vRdxWmsHead.UnloadingBayName === null ||
          vRdxWmsHead.UnloadingBayName === undefined
            ? icurrentUnloadingBayValue?.Name1
            : vRdxWmsHead.UnloadingBayName,
        A_Curr:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Uid
            : vRdxWmsHead.A_Curr,
        A_Currname:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Name1
            : vRdxWmsHead.A_Currname,
        A_ExRate:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? iCurrencyArr?.Rate
            : vRdxWmsHead.A_ExRate,
        A_PayMode:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? currentPayMode
            : vRdxWmsHead.A_PayMode, //on load sPaymode[0]?.Uid but refreshing default value, && paymode has default value so we are checking with curr
        TaxType:
          vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
            ? vDefaultTaxType
            : vRdxWmsHead.TaxType,
        A_Loc:
          vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead.A_Loc === null ||
          vRdxWmsHead.A_Loc === undefined
            ? vRdxDBLocation[0].UID
            : vRdxWmsHead.A_Loc,
        A_Buyer:
          vRdxWmsHead.A_Buyer == "" ||
          vRdxWmsHead.A_Buyer === null ||
          vRdxWmsHead.A_Buyer === undefined
            ? BuyerId
            : vRdxWmsHead.A_Buyer,
        A_Type:
          vRdxWmsHead.A_Type == "" ||
          vRdxWmsHead.A_Type === null ||
          vRdxWmsHead.A_Type === undefined
            ? iOutboundTypeArr
            : vRdxWmsHead.A_Type,
      })
    );

    fLoad_Grid(
      vRdxWmsHead.A_VocNo, //0
      0, //srno
      vRdxWmsHead.A_Rounding,
      setDetailGridData,
      setFooterObj,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp
    );

    GetDefaultDrCrAccount(
      vRdxWmsHead.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? vDocLoadingArr[0]?.VocTyp
        : vRdxWmsHead.A_VocTyp,
      vRdxWmsHead.A_Curr == "" ||
        vRdxWmsHead.A_Curr === null ||
        vRdxWmsHead.A_Curr === undefined
        ? currentPayMode
        : vRdxWmsHead.A_PayMode,
      vRdxWmsHead.A_Party, //vRdxWmsHead.A_Party on load empty
      dispatch
    );

    let iInterCompanyDependency = {
      B_TaxPerc: vRdxGRNtax1[0]?.Perc,
      B_TaxPerc2: vRdxGRNtax2[0].Perc,
    };
    //if inter.comp then tax group should be 0
    if (iDefaultTaxType == sTax[1].Uid || iDefaultTaxType == sTax[2].Uid) {
      iInterCompanyDependency = InterCompanyDependency(
        vRdxDBKernObj?.DEF_ZERO_TAX_CODE?.Val,
        vRdxDBKernObj?.DEF_ZERO_CESS_CODE?.Val
      );
    }
    GetItemStock(
      sBufferObj.B_Itmcd,
      sBufferObj.B_Srno,
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? vRdxDBLocation[0].UID
        : vRdxWmsHead.A_Loc,
      setItemStock,
      0
    );
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      vRdxWmsHead.A_Curr == "" ||
        vRdxWmsHead.A_Curr === null ||
        vRdxWmsHead.A_Curr === undefined
        ? iCurrencyArr.Rate
        : vRdxWmsHead.A_ExRate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      vRdxWmsHead?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      iInterCompanyDependency.B_TaxPerc, //tax1%
      iInterCompanyDependency.B_TaxPerc2, //tax%2
      0, //sBufferObj.AddCess,
      0 //Rounding
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      B_TDiscPerc: vRdxWmsHead?.A_DiscPerc,
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, vRdxDBLocation, vRdxGRNtax1, vRdxGRNtax2]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGCSearchBtn_Toggle_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGCSearchBtn_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);
  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined ||
      vRdxWmsHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_DocStat,
  ]);
  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  // useEffect(() => {
  //   const handleClick = (event) => {
  //     if (sItemToggleDropdown) {
  //       const toggleElement = event.target.closest(".toggleSearch");
  //       if (!toggleElement) {
  //         setItemToggleDropdown(false);
  //         setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  //       }
  //     }
  //   };
  //   document.addEventListener("click", handleClick);
  //   return () => {
  //     document.removeEventListener("click", handleClick);
  //   };
  // }, [sItemToggleDropdown]);

  // useEffect(() => {
  //   const handleClick = (event) => {
  //     if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
  //       const toggleElement = event.target.closest(".toggleSearch");
  //       if (!toggleElement) {
  //         setItemToggleDropdown(false);
  //         setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  //       }
  //     }
  //   };
  //   document.addEventListener("click", handleClick);
  //   return () => {
  //     document.removeEventListener("click", handleClick);
  //   };
  // }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setToggleGrid(false);
    }
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("WmsOutboundGRVContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "P";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );
  useEffect(() => {
    GetOSAmount(vRdxWmsHead.A_Loc, vRdxWmsHead.A_Party, setOsAmount);
  }, [vRdxWmsHead.A_Loc, vRdxWmsHead.A_Party]);
  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  const FocusOnLoad = useRef(null);
  useEffect(() => {
    // FocusOnLoad.current?.focus();
  }, []);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "B_Srno", headerName: "Sr.No", width: 50 },
    { field: "B_Itmcd", headerName: "Item Code", width: 100 },
    // { field: "B_Barcode", headerName: "Barcode", width: 100 },
    { field: "ItmName", headerName: "Item Name", width: 300 },
    { field: "B_Qty", headerName: "Qty", width: 100 },
    { field: "B_Unit", headerName: "B_Unit", width: 100, hide: true },
    { field: "UnitName", headerName: "Unit", width: 100 },
    { field: "B_URateFc", headerName: "Unit Rate", width: 100 },
    { field: "B_GrossAmt", headerName: "Gross.Amt", width: 90 },
    { field: "B_LDiscPerc", headerName: "L Disc %", width: 100 },
    { field: "B_LDiscAmt", headerName: "L Disc.Amt", width: 100 },
    { field: "B_FocAmt", headerName: "FocAmt", width: 100 },
    { field: "B_NetAmt", headerName: "Net value", width: 100 },
    { field: "B_ExciseTaxNetAmt", headerName: "B_ExciseTaxNetAmt", width: 130 },
    { field: "B_TaxAmt", headerName: "B_TaxAmt", width: 100 },
    { field: "B_ExciseTaxPerc", headerName: "ExciseTaxPerc", width: 100 },
    { field: "B_ExciseTaxAmt", headerName: "ExciseTaxAmt", width: 100 },
    { field: "B_TaxDept", headerName: "B_TaxDept", width: 100 },
    { field: "SplDiscAmt1", headerName: "SplDisc", width: 150 },
    { field: "B_TDiscAmt", headerName: "B_TDiscAmt", width: 100, hide: true },
    { field: "B_TDiscPerc", headerName: "B_TDiscPerc", width: 100, hide: true },
    { field: "B_TaxPerc", headerName: "B_TaxPerc", width: 100, hide: true },
    { field: "B_TaxDept2", headerName: "B_TaxDept2", width: 100, hide: true },
    { field: "B_TaxPerc2", headerName: "B_TaxPerc2", width: 100, hide: true },
    { field: "B_TaxAmt2", headerName: "B_TaxAmt2", width: 100, hide: true },
    { field: "AddCess", headerName: "AddCess", width: 100, hide: true },
    {
      field: "B_NetAddCess",
      headerName: "B_NetAddCess",
      width: 100,
      hide: true,
    },
  ]);

  //GCSearch
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "PartyName", headerName: "Vendor", width: 250 },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "A_NetAmt", headerName: "NetAmt", width: 90 },
    { field: "SalesGroup", headerName: "Sales Group", width: 130 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_VocTyp", headerName: "A_VocTyp", width: 90, hide: true },
  ]);

  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ]);

  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);

  const [GridDataSalesHistoryColumns, setGridDataSalesHistoryColumns] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "A_VocNo", headerName: "Inv.N0", width: 130 },
      {
        field: "A_PostDt",
        headerName: "Date",
        width: 130,
        valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
      },
      { field: "Unit", headerName: "Unit", width: 130 },
      { field: "GrossAmt", headerName: "GrossAmt", width: 130 },
      { field: "NetAmt", headerName: "NetAmt", width: 130 },
      { field: "Qty", headerName: "Qty", width: 130 },
    ]);
  //customer
  const [
    xGC_Toggle_Head_Customer_GridColumns,
    setxGC_Toggle_Head_Customer_GridColumns,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 90 },
    { field: "Name2", headerName: "Name2", width: 450 },
    { field: "Name1", headerName: "Name1", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);

  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsWmsSiDetail,
      "OUTBOUND_GRV_DETAIL",
      GridDataColumnsWmsSiDetail
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "OUTBOUND_GRV_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "OUTBOUND_GRV_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataSalesHistoryColumns,
      "OUTBOUND_GRV_HISTORY",
      GridDataSalesHistoryColumns
    );
    GetGitterColumns(
      setxGC_Toggle_Head_Customer_GridColumns,
      "OUTBOUND_GRV_CUST",
      xGC_Toggle_Head_Customer_GridColumns
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_PostDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={vRdxWmsHead.A_DocStat != "ENTER" ? true : false}
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          vRdxWmsHead.A_DocStat == "ENTER" || vRdxWmsHead.A_DocStat == "DRAFT"
            ? false
            : true
        }
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-outbound-grv">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-inbound-grn-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <CmpButton
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat != "ENTER" ? true : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <CmpButton
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat == "ENTER" ||
                        vRdxWmsHead.A_DocStat == "DRAFT"
                          ? false
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="PrintId"
                      onClick={(e) => {
                        fPrint("P");
                      }}
                    >
                      Purchase Return
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("FC");
                      }}
                    >
                      Document
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("");
                      }}
                    >
                      Purchase Return-Dollar
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="IdAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>
                {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}

                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      // { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>
              </Grid>

              <>
                <div id="wms-salese-invoice-id">
                  <div className="wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      //grid saleshistory
                      sToggleGrid={sToggleGrid}
                      sGridSalesHistoryRowData={sGridSalesHistoryRowData}
                      GridDataSalesHistoryColumns={GridDataSalesHistoryColumns}
                      //grid saleshistory end
                      xDisableBasedOnGridDataLength={sDetailGridData.length > 0}
                      xPaymodeEnable={sPaymodeEnable}
                      xOsAmount={sOsAmount}
                      xErrorMsg={sErrorMsg}
                      vRdxuserLoc={vRdxDBLocation}
                      xKey={fKeyOutboundGRV}
                      vRdxWmsHead={vRdxWmsHead}
                      sArr={sArr}
                      fonSelectedGrnType={fGrnType}
                      sDocLoadingGrnType={sDocLoading}
                      sOutboundType={sOutboundType}
                      sPaymode={sPaymode}
                      sUnloading={sUnloading}
                      sCurrency={sCurrency}
                      sTax={sTax}
                      fGrnDate={fGrnDate}
                      fInvNo={fInvNo}
                      fInvDate={fInvDate}
                      fOutboundType={fOutboundType}
                      fPaymode={fPaymode}
                      fSelectedUnloading={fUnloading}
                      fSelectedCurrency={fCurrency}
                      fTax={fTax}
                      fOffer={fOffer}
                      fTaxable={fTaxable}
                      fLocation={fLocation}
                      xFocusInput={fFocusInput}
                      inputFocus={FocusOnLoad}
                      //customer

                      xGC_Toggle_Head_Customer_DropDown_Arr={
                        xGC_Toggle_Head_Customer_DropDown_Arr
                      } //sub input arr
                      xfGC_Toggle_Head_Customer_Name={
                        xfGC_Toggle_Head_Customer_Name
                      } //onchange main input
                      xGC_Toggle_Head_Customer_Toggle={
                        sGC_Toggle_Head_Customer_ToggleDropDowm
                      } //boolean true  false
                      xGC_Toggle_Head_Customer_onKeyUp={
                        fGC_Toggle_Head_Customer_onKeyUp
                      } //main input enter
                      xGC_Toggle_Head_Customer_SearchDropdownObj={
                        sGC_Toggle_Head_Customer_SearchDropdownObj
                      } //sub input obj
                      xGC_Toggle_Head_Customer_Dropdown_onChange={
                        fGC_Toggle_Head_Customer_Dropdown_onChange
                      } //sub input onchange
                      xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load={
                        fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                      } //sub input load
                      xGC_Toggle_Head_Customer_GridColumns={
                        xGC_Toggle_Head_Customer_GridColumns
                      } //sub input col
                      xGC_Toggle_Head_Customer_GridData={
                        sGC_Toggle_Head_Customer_GridData
                      } //sub input grid
                      xfGC_Toggle_Head_Customer_OnCellKeyDown={
                        fGC_Toggle_Head_Customer_OnCellKeyDown
                      } //sub input row enter
                      xfGC_Toggle_Head_Customer_OnRowClick={
                        fGC_Toggle_Head_Customer_OnRowClick
                      } //sub input row click
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        sTransItemStockObj={sTransItemStockObj}
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() ==
                          "Y"
                        }
                        fonChangeInputLDiscAmt={fonChangeInputLDiscAmt}
                        fGrossAmt={fGrossAmt}
                        fFocusShowSalesHistoryGrid={fFocusShowSalesHistoryGrid}
                        xItemStock={sItemStock}
                        xContent_Focus={fContent_Focus}
                        xContent_Blur={fContent_Blur}
                        xErrorMsgDetail={sErrorMsgDetail}
                        vRdxWmsHead={vRdxWmsHead}
                        xKey={fKeyOutboundGRVContent}
                        xFocusInput={fFocusInput}
                        xBufferObj={sBufferObj}
                        sUnit={sUnit}
                        sFocFlagArr={sFocFlagArr}
                        sTypeArr={TypeArr}
                        vRdxGRNtax1={vRdxGRNtax1}
                        vRdxGRNtax2={vRdxGRNtax2}
                        fUnit={fUnit}
                        fUnitRate={fUnitRate}
                        fUnitRateSave_onKeyUp={fUnitRateSave_onKeyUp}
                        fExcise={fExcise}
                        fNetExcise={fNetExcise}
                        fTaxGroup={fTaxGroup}
                        fCessGroup={fCessGroup}
                        fNetAmt={fNetAmt}
                        fLDiscPer={fLDiscPer}
                        fOpenContentItemSearchModalKey={fItemSearchKey}
                        fQty={fQty}
                        fBaseRate={fBaseRate}
                        //GC toggle
                        fItemName={fItemName} //onchange main input
                        xMediaQuery={vMediaQuery} //mobile screen
                        xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                        xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                        xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                        xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                        xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                        xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                        xData={ItemSearchData} // GCToggleSearch-select-tag arr
                        xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                        xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                        xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch-
                        // togggle narration
                        fNarration={fNarration}
                        xNarrationToggleDropdown={sNarrationToggleDropdown}
                        xrowDropdownNarrationSearch={sNarrationSearchGridData}
                        xOnCellKeyNarrationDown={OnCellKeyNarrationDown}
                        xOnRowNarrationClick={OnRowNarrationClick}
                        fNarrationKeyEnter={fNarrationKeyEnter}
                      />
                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={fDetail_Grid_onRowClick}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div style={{ height: "30vh", width: "100%" }}>
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={fDetail_Grid_onRowClick}
                          hideFooter={sDetailGridData.length < 100}
                          // components={{
                          //   Toolbar: GridToolbar,
                          // }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <WmsFooter
                      xErrorMsg={sErrorMsg}
                      xFooterObj={sFooterObj}
                      fFocusRounding={fFooter_Rounding_Focus}
                      fBlurRounding={fFooter_Rounding_Blur}
                      fOpenDiscountPercentageModal={
                        fOpenDiscountPercentageModal
                      }
                      xBuyer={sBuyer}
                      xKey={fKeyOutboundGRV}
                      vRdxWmsHead={vRdxWmsHead}
                      sArr={sArr}
                      fBuyer={fBuyer}
                      fNote={fNote}
                      fHeadNarration={fHeadNarration}
                      fRounding={fRounding}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "70vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                hideFooter={sDetailGridData.length < 100}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsFooter
              xErrorMsg={sErrorMsg}
              xFooterObj={sFooterObj}
              fFocusRounding={fFooter_Rounding_Focus}
              fBlurRounding={fFooter_Rounding_Blur}
              fOpenDiscountPercentageModal={fOpenDiscountPercentageModal}
              xBuyer={sBuyer}
              xKey={fKeyOutboundGRV}
              vRdxWmsHead={vRdxWmsHead}
              sArr={sArr}
              fBuyer={fBuyer}
              fNote={fNote}
              fHeadNarration={fHeadNarration}
              fRounding={fRounding}
            />
          </div>
        </Box>
      </Modal>
      {/* Reverse Modal */}
      <GCReverse
        open={sReverseTransactionModal}
        fCloseReverseTransactionModal={(e) => {
          fCloseReverseTransactionModal(setReverseTransactionModal);
        }}
        sRevNarr={sRevNarr}
        setRevNarr={setRevNarr}
        fReverse={(e) => {
          fReverse(fSave, setRevNarr, setReverseTransactionModal);
        }}
      />
      {/* Search  */}
      <GCSearchBtn
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sSearchLoactionArr}
        xSalesGroup={sGCSeachSalesGroupSearch}
        xSearchModalObj={sSearchModalObj}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangePartyModal={fonChangePartyModal}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        fonChangeSalesGroupModal={fonChangeSalesGroupModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Outbound GRV - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
        xSalesGroupVal={sSearchModalObj.SalesGroup}
        xPartyVal={sSearchModalObj.Party}
        xPartyNameVal={sSearchModalObj.PartyName}
        //new Search lookUp
        xfGCSearchBtn_Name={xfGCSearchBtn_Name}
        xGCSearchBtn_Toggle={sGCSearchBtn_Toggle_ToggleDropDowm}
        xGCSearchBtn_onKeyUp={fGCSearchBtn_onKeyUp_onKeyUp}
        xGCSearchBtn_SearchDropdownObj={
          sGCSearchBtn_SearchDropdownObj_SearchDropdownObj
        }
        xGCSearchBtn_Dropdown_onChange={xGCSearchBtn_Dropdown_onChange}
        xGCSearchBtn_Dropdown_OnKeyUp_Load={fGCSearchBtn__Dropdown_OnKeyUp_Load}
        xGCSearchBtn_Columns_DropdownSearch={
          xGCSearchBtn_Columns_DropdownSearch
        }
        xGCSearchBtn_GridData={sGCSearchBtn_GridData}
        xfGCSearchBtn_OnRowClick={fGCSearchBtn_OnRowClick}
        xfGCSearchBtn_OnCellKeyDown={fGCSearchBtn_OnCellKeyDown}
      />
      {/* Audit  */}
      {/* <GCAudit
        xOpen={sAuditModal}
        xTitle={"AUDIT"}
        fCloseAuditModal={fCloseAuditModal}
        sAuditSelectArr={sAuditSelectArr}
        GridDataAuditColumns={GridDataAuditColumns}
        GridDataAuditRows={sGridDataAuditRows}
        xAuditId={xAuditId}
        fonChangeAuditSelect={fonChangeAuditSelect}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
      /> */}
      <GCAuditTblCard
        xOpen={sAuditModal}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        fCloseAuditModal={setAuditModal}
        trnTyp={sTrnTyp}
        vocTyp={vRdxWmsHead.A_VocTyp}
        vocNo={vRdxWmsHead.A_VocNo}
      />
      {/* DiscountPercentage  */}
      <GCDiscountPercentage
        sDiscountPercentageModal={sDiscountPercentageModal}
        fCloseDiscountPercentageModal={fCloseDiscountPercentageModal}
        xGrossAmount={sFooterObj.A_GrossAmt}
        xLDiscAmount={sFooterObj.A_LDiscAmt}
        xTDiscAmount={sDiscPerModelObj.A_TDiscAmt}
        xTDiscPer={sDiscPerModelObj.A_DiscPerc}
        fonChangeInputDiscountModal={fonChangeInputDiscountModal}
        fOnChangeTDiscAmtModal={fOnChangeTDiscAmtModal}
        GetApplyTDiscount={GetApplyTDiscount}
        xErrorMsg_DiscPerc={sErrorMsgDiscountModal.A_DiscPerc}
        xErrorMsg_TDiscAmt={sErrorMsgDiscountModal.A_TDiscAmt}
        xRdx_DocStatus={vRdxWmsHead.A_DocStat !== "ENTER"}
      />
      <Modal
        open={sDocumentModal}
        onClose={fCloseDocumentModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-popup">on progerss document...</Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
    </div>
  );
}
